import * as React from "react";
import { StyledHeading, DescriptionCol } from "components/inputs/InputSetupWizard";
import IlluminateList from "./IlluminateList";
import { ILLUMINATE_PACK_TYPES } from "../SelectIlluminateStep";
const SelectSpotlightPacks = ({
  spotlightPacksData,
  isLoadingSpotlightPacksData,
  selectedSpotlightPacks,
  setSelectedSpotlightPacks,
  setTouched
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledHeading, null, "Select Illuminate Spotlight Packs"), /* @__PURE__ */ React.createElement(DescriptionCol, null, /* @__PURE__ */ React.createElement("p", null, "Please select one or more Illuminate Spotlight Packs to use with logs received from this Input. Spotlight packs install relevant dashboards, sigma rules and events that read logs parsed by Illuminate to GIM schema."), /* @__PURE__ */ React.createElement("p", null, "Content Packs that have already been installed will be shown as grayed out.")), /* @__PURE__ */ React.createElement(
  IlluminateList,
  {
    isLoading: isLoadingSpotlightPacksData,
    listData: spotlightPacksData,
    selectedPacks: selectedSpotlightPacks,
    setSelectedPacks: setSelectedSpotlightPacks,
    setTouched,
    type: ILLUMINATE_PACK_TYPES.SPOTLIGHT
  }
));
export default SelectSpotlightPacks;
